// src/components/ProgressBar.js
import React from 'react';

export default function ProgressBar({ pct }) {
  return (
    <div style={{ height: 4, background: 'rgba(107,30,46,0.12)', width: '100%' }}>
      <div style={{
        height: '100%',
        width: `${Math.round(pct)}%`,
        background: '#C9A84C',
        transition: 'width 0.4s ease'
      }} />
    </div>
  );
}
